import { render, staticRenderFns } from "./deduplicationipcontrol-add-or-update.vue?vue&type=template&id=7338f37e&"
import script from "./deduplicationipcontrol-add-or-update.vue?vue&type=script&lang=js&"
export * from "./deduplicationipcontrol-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports